import { makeStyles } from "@material-ui/core/styles";
import { Color } from "../../../../../constants/colors";

export const useStyles = makeStyles((theme) => ({
    button: {
        width: 32,
        height: 32,
        borderRadius: 51,
        padding: "11px 16px",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "Inter, sans-serif",
        fontStyle: "normal",
        fontWeight: "bold",
        fontSize: 12,
        textTransform: "none"
    },
    iconTrash: {
        fill: Color.gray5
    },
    btnNewWorkArea: {
        background: "#7175FA",
        color: "#F6F6F6",
        "&:hover": {
            background: "#6462F3",
        },
    },
    icon: {
        paddingTop: 5,
        height: 30,
        width: 30,
        fontWeight: "bold"
    },
    classRow: {
        cursor: "pointer",
        "& button": {
            visibility: "hidden",
        },
        "&:hover": {
            "& button": {
                visibility: "visible"
            }
        }
    },
    classHead: {
        color: theme.colors.grey5,
        textAlign: "left"
    },
    classCell: {
        color: theme.colors.grey5,
    },
}));


export default useStyles;
